import copy from 'copy-to-clipboard';

import { IS_PHONE } from "../helpers/consts"

export default () => {
	if(!IS_PHONE) return;
	const btn = document.querySelector('.js-mob-share-btn');
	if(btn) {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			const url = window.location.href;
			if (navigator.share) {
				const title = document.title;
				navigator.share({
					title: title,
					url: url
				}).then(() => {
					console.log('Thanks for sharing!');
				})
				.catch(console.error);
			} else {
				copy(url);
				alert('Link copied to clipboard')
			}
		});
	}
}